import { Form } from 'antd';
import InlineFileUpload from 'components/InlineFileUpload';
import { MAX_UPLOAD_FILESIZE } from 'const/attachments';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NouveauDossierConcessionnaireData } from 'types/Concessionnaire';
import { getValueFromEvent } from 'utils/files';
import type { EventArgs } from 'rc-field-form/lib/interface';

interface FilesUploadProps {
  onDevisChange?: (files?: NouveauDossierConcessionnaireData['devis']) => void;
  onOtherFilesChange?: (
    files?: NouveauDossierConcessionnaireData['otherFiles'],
  ) => void;
}

export default function FilesUpload({
  onDevisChange,
  onOtherFilesChange,
}: FilesUploadProps) {
  const { t } = useTranslation();
  const handleDevisFromEvent = useCallback(
    (event: EventArgs[0]) => {
      const files = getValueFromEvent(event) as
        | NouveauDossierConcessionnaireData['devis']
        | undefined;
      onDevisChange?.(files);
      return files;
    },
    [onDevisChange],
  );

  const handleOtherFilesFromEvent = useCallback(
    (event: EventArgs[0]) => {
      const files = getValueFromEvent(event) as
        | NouveauDossierConcessionnaireData['otherFiles']
        | undefined;
      onOtherFilesChange?.(files);
      return files;
    },
    [onOtherFilesChange],
  );

  return (
    <>
      <Form.Item<NouveauDossierConcessionnaireData>
        name="devis"
        required
        rules={[
          {
            required: true,
            message: t('nouveau_formulaire:devis:required'),
          },
        ]}
        valuePropName="fileList"
        getValueFromEvent={handleDevisFromEvent}
        label={t('nouveau_formulaire:devis:label')}
      >
        <InlineFileUpload
          browseLabel={t('add_dossier_beneficiary:files_browse')}
          maxSizeLabel={t('add_dossier_beneficiary:files_max_size', {
            size: MAX_UPLOAD_FILESIZE,
          })}
          multiple={false}
          maxCount={1}
        />
      </Form.Item>

      <Form.Item<NouveauDossierConcessionnaireData>
        name="otherFiles"
        valuePropName="fileList"
        getValueFromEvent={handleOtherFilesFromEvent}
        label={t('nouveau_formulaire:other_files:label')}
      >
        <InlineFileUpload
          browseLabel={t('add_dossier_beneficiary:files_browse')}
          maxSizeLabel={t('add_dossier_beneficiary:files_max_size', {
            size: MAX_UPLOAD_FILESIZE,
          })}
          multiple
          maxCount={10}
        />
      </Form.Item>
    </>
  );
}
